import e from "./TypesenseSearch.vue2.js";
import "./TypesenseSearch.vue3.js";
import o from "../../_virtual/_plugin-vue_export-helper.js";
const p = /* @__PURE__ */ o(e, [["__scopeId", "data-v-f25e59cf"]]);
export {
  p as default
};
